import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  @Input() childLinkLabel = 'Administration';
  @Input() subchildLinkLabel = 'Notification Message Setup';
  constructor(
    private _location: Location
  ) { }

  ngOnInit(): void {
  }

  backToPreviousPage() {
    this._location.back();
  }
}
